.wrapper {
  margin: 20px 0;
  position: relative;
}

.line {
  &1 {
    background-image: linear-gradient(to left, #fff, #ccc);
    height: 10px;
    margin: 0 277px 16px 15px;
    width: 11%;
  }

  &2 {
    background-image: linear-gradient(to left, #fff, #ccc);
    height: 16px;
    margin: 16px 0 8px 15px;
    width: 95%;
  }

  &3 {
    background-image: linear-gradient(to left, #fff, #ccc);
    height: 16px;
    margin: 8px 60px 0 15px;
    width: 77%;
  }
}
